module.exports = __webpack_public_path__ + "img/Screenshot-2.c66ab630.png";